import React from "react";
import examAvatarInfo from "../../../../assest/images/card-image/ItemAvatarInfo.png";
import IExamRankInformationState, { IExamRankInformationProps } from "./ExamRankInformation.models";
import ExamLevelChartComponent from "../exam-level-chart/ExamLevelChartComponent";
import ExamPerformancePercentageChartComponent from "../exam-performance-percentage-chart/ExamPerformancePercentageChartComponent";

export default class ExamRankInformation extends React.PureComponent<IExamRankInformationProps, IExamRankInformationState> {
    constructor(props: any) {
        super(props);
        this.state = { loading: false }
    }

    render(): React.ReactNode {
        let { examRankInformation } = this.props

        return (<>
            {examRankInformation && this.examInformationContentView()}
            {examRankInformation && this.chartView()}
            {examRankInformation && this.examPerformancePercentageChartView()}
        </>);
    }

    examInformationContentView() {
        let { examRankInformation, examRank, examInformation } = this.props
        let items = [
            { title: 'رتبه ی کل آزمون:', value: examRank },
            { title: 'نمره تراز:', value: this.props.examInformation?.examLevel },
        ]

        return (
            <div className="exam-info-view-area">
                <div className="tk-card">
                    <div className="card-icon">
                        <img src={examAvatarInfo} style={{ width: '64px' }} alt="exam icon" />
                    </div>
                    <div className="card-title">
                        <label className="font-bold f-16 text-dark">رتبه ی شما</label>
                    </div>
                    <div className="col-12 user-info">
                        {
                            items.map((item, index) => {
                                return <div className="tk-inline" key={index}>
                                    <div className="col-6 notspace text-dark">
                                        <label>{item.title}</label>
                                    </div>
                                    <div className="col-6 notspace info">
                                        <label>{item.value}</label>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                </div>
            </div>
        )
    }

    chartView() {
        return (
            <div className="exam-info-view-area">
                <div className="tk-card pb-3">
                    <div className="card-icon">
                        <img src={examAvatarInfo} style={{ width: '64px' }} alt="exam icon" />
                    </div>
                    <div className="card-title">
                        <label className="font-bold f-16 text-dark">نمودار تراز</label>
                    </div>
                    <ExamLevelChartComponent chartData={this.props.examRankInformation?.chartData} />
                </div>
            </div>
        )
    }

    examPerformancePercentageChartView() {
        let { examInformation } = this.props
        let chartData: { title: string, value: number, color: string }[] = [
            {
                title: 'پاسخ درست',
                color: '#90ed7d',
                value: examInformation?.examCorrectAnswer ?? 0
            },
            {
                title: 'پاسخ نادرست',
                color: '#f53c56',
                value: examInformation?.examWrongAnswer ?? 0
            },
            {
                title: 'پاسخ نزده',
                color: '#cfd8dc',
                value: examInformation?.examUnAnswer ?? 0
            },
        ]

        return (
            <div className="exam-info-view-area">
                <div className="tk-card pb-3">
                    <div className="card-icon">
                        <img src={examAvatarInfo} style={{ width: '64px' }} alt="exam icon" />
                    </div>
                    <div className="card-title">
                        <label className="font-bold f-16 text-dark">نمودار عملکرد</label>
                    </div>
                    <ExamPerformancePercentageChartComponent chartData={chartData} totalQuestion={this.props.examInformation?.totalQuestion ?? 0} />
                </div>
            </div>
        )
    }
}